/**
 * Utility function to get the logo path based on quality setting
 * 
 * @param {string} logoName - Base logo name (e.g., 'logo-1.svg' or 'main.svg')
 * @param {string} quality - Quality level: 'low_quality', 'medium_quality', or 'original'
 * @returns {string} Full path to the logo file
 */
export const getLogoPath = (logoName, quality = 'medium_quality') => {
  // Ensure logoName doesn't include path
  const baseName = logoName.replace(/^\/images\//, '').replace(/^\/logos\//, '').replace(/^[^/]+\//, '');
  
  // Map quality to folder name (same structure as images, videos and models)
  const qualityFolder = quality === 'original' ? 'original' : quality;
  
  // Return the full path with quality folder
  return `/images/${qualityFolder}/logos/${baseName}`;
};

/**
 * Get logo path from a full path, replacing with quality folder if needed
 * 
 * @param {string} fullPath - Full path like '/logos/logo-1.svg' or '/images/medium_quality/logos/logo-1.svg'
 * @param {string} quality - Quality level: 'low_quality', 'medium_quality', or 'original'
 * @returns {string} Updated path with quality folder
 */
export const updateLogoPath = (fullPath, quality = 'medium_quality') => {
  // Extract logo name from path (handles both /logos/logo.svg and /images/quality/logos/logo.svg)
  const match = fullPath.match(/\/(?:logos\/|images\/[^/]+\/logos\/)([^/]+\.svg)$/);
  if (!match) {
    // If path doesn't match expected format, return as-is
    return fullPath;
  }
  
  const logoName = match[1];
  return getLogoPath(logoName, quality);
};
